import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    conpanytaxId,
    taxCalculationPeriod,
    userName,
    where,
  },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [taxCalculationPeriod.name]: "",
  [conpanytaxId.name]: "",
  [userName.name]: "",
  [where.name]: "",
};

export default initialValues;
